/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import match from "assets/music_glass_new.mp3";
import firstReady from "assets/music_marimba_lo_on.mp3";
import proceed from "assets/music_marimba_hi_on.mp3";
import sessionProceed from "assets/music_marimba_chord_major.mp3";
import sessionCancelled from "assets/music_marimba_chord_lo.mp3";

export const UpduoSounds = {
  match: new Audio(match),
  firstReady: new Audio(firstReady),
  proceed: new Audio(proceed),
  sessionComplete: new Audio(sessionProceed),
  sessionCancelled: new Audio(sessionCancelled),
};
